
      import { initializeStaticPage } from "./js/static-pages.js";
      initializeStaticPage();
    